import { useEffect, useState } from "react";
import { PiFileXls, PiFileTxt, PiFilePdf, PiFileDoc, PiFileJpg, PiFilePng } from "react-icons/pi";

export const fileColors = {
  pdf: {bg: "#FFE1E2", color: "#E10503"},
  docx: {bg: "#F3FCFD", color: "#0283D3"},
  doc: {bg: "#F3FCFD", color: "#0283D3"},
  jpg: {bg: "#FFF8E1", color: "#F9A825"},
  jpeg: {bg: "#FFF8E1", color: "#F9A825"},
  png: {bg: "#FFF8E1", color: "#F9A825"},
  txt: {bg: "#EBFCEC", color: "#015D2D"},
  xls: {bg: "#EBFCEC", color: "#015D2D"},
  xlsx: {bg: "#EBFCEC", color: "#015D2D"},
}

export default function GetFileTypeElement({file}) {

    const [fileType, setFileType] = useState()

    useEffect(() => {
        setFileType(file.name.split(".").pop().toLowerCase());
    }, [file])

    if (fileType === "pdf") {
      return <PiFilePdf className="fileTypeIcon w-[24px] h-[24px] min-w-[24px] min-h-[24px] p-[4px] rounded-[4px] bg-[#FFE1E2]" color="#E10503"/>;
    }
    if (fileType === "docx") {
      return <PiFileDoc className="fileTypeIcon w-[24px] h-[24px] min-w-[24px] min-h-[24px] p-[4px] rounded-[4px] bg-[#F3FCFD]" color="#0283D3"/>;
    }
    if (fileType === "doc") {
      return <PiFileDoc className="fileTypeIcon w-[24px] h-[24px] min-w-[24px] min-h-[24px] p-[4px] rounded-[4px] bg-[#F3FCFD]" color="#0283D3"/>;
    }
    if (fileType === "jpg" || fileType === "jpeg") {
      return <PiFileJpg className="fileTypeIcon w-[24px] h-[24px] min-w-[24px] min-h-[24px] p-[4px] rounded-[4px] bg-[#FFF8E1]" color="#F9A825" />;
    }
    if (fileType === "png") {
      return <PiFilePng  className="fileTypeIcon w-[24px] h-[24px] min-w-[24px] min-h-[24px] p-[4px] rounded-[4px] bg-[#FFF8E1]" color="#F9A825" />;
    }
    if (fileType === "txt") {
      return <PiFileTxt className="fileTypeIcon w-[24px] h-[24px] min-w-[24px] min-h-[24px] p-[4px] rounded-[4px] bg-[#EBFCEC]" color="#015D2D"/>;
    }
    if (fileType === "xls" || fileType === "xlsx") {
      return <PiFileXls className="fileTypeIcon w-[24px] h-[24px] min-w-[24px] min-h-[24px] p-[4px] rounded-[4px] bg-[#EBFCEC]" color="#015D2D"/>;
    }

    return <></>;
  };